import modalConfirmation from '../../../shared/components/modal-response/modal-response.view.html';
let inject = [
  '$scope',
  'MyPaymentsDetailService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  'NgTableParams',
  '$stateParams'
];

class MyPaymentsDetailController{
  constructor ($scope, MyPaymentsDetailService, $state, $rootScope, SharedService, $uibModal, NgTableParams, $stateParams) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.NgTableParams = NgTableParams;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.MyPaymentsDetailService = MyPaymentsDetailService;
    this.SharedService = SharedService;
    this.payment = {};
    this.loandingPayments = false;
  }

  $onInit(){
    this.getDatas();
  }
  
  getDatas() {
    let documentNumber = '';
    try{
      documentNumber = this.$stateParams.paymentId;
      
    }
    catch(e){}
    this.loandingPayments = true;
    
    this.MyPaymentsDetailService.getPaymentDetail(documentNumber).then(response => {
      if(!response) return this.$state.go('home.myPaymentsList');
      this.payment = response;
      this.loandingPayments = false;
      this.initTable();
    }).catch((reason) => {
      this.loandingPayments = false;
    });
  }
  
  initTable() {
    this.ngTableColsPayList = [
      {
        field: "numero_documento",
        title: "Número Dcto.",
        sortable: "numero_documento",
        filter: { "numero_documento": "text" },
        show: true
      },
      {
        field: "valor_recaudo",
        title: "Valor Dcto.",
        sortable: "valor_recaudo",
        filter: { "valor_recaudo": "text" },
        show: true
      },
      {
        field: "valor_recaudo",
        title: "Vr. pte. de pago",
        sortable: "valor_recaudo",
        filter: { "valor_recaudo": "text" },
        show: true
      },
      {
        field: "valor_recaudo",
        title: "Vr. Pagado",
        sortable: "valor_recaudo",
        filter: { "valor_recaudo": "text" },
        show: true
      }
    ];
  
    let initialParams = {
      count: 20,
      sorting: { Fecha_Recaudo: "desc" }
    };
  
    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.payment.facturas
    };
  
    this.ngTableConfigPayList = new this.NgTableParams(initialParams, initialSettings);
  }
  
  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

MyPaymentsDetailController.$inject = inject;

export default MyPaymentsDetailController;




/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/pay-zone/my-payments/my-payments-detail/my-payments-detail.controller.js
 **/